var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "right-menu-wrapper"
  }, [_c('div', {
    staticClass: "right-menu-margin"
  }, [_c('div', {
    staticClass: "right-menu-title"
  }, [_vm._v("目录")]), _vm._v(" "), _c('div', {
    staticClass: "right-menu-content"
  }, _vm._l(_vm.headers, function (item, i) {
    return _c('div', {
      key: i,
      class: ['right-menu-item', 'level' + item.level, {
        active: item.slug === _vm.hashText
      }]
    }, [_c('a', {
      attrs: {
        "href": '#' + item.slug
      }
    }, [_vm._v(_vm._s(item.title))])]);
  }), 0)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };